export default {"src":"/_next/static/media/twin-beds-outline.5815a157.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};